// Organization.geography is stored as a JSON array of country names; older rows
// may still hold free text, which is shown as it is.
export function geographyLabel(geography: string | null | undefined): string | null {
  if (!geography) return null;
  try {
    const parsed: unknown = JSON.parse(geography);
    if (Array.isArray(parsed)) return parsed.filter((c) => typeof c === "string" && c).join(", ") || null;
  } catch { /* free text */ }
  return geography;
}
